import { render, staticRenderFns } from "./TypeItem.vue?vue&type=template&id=5d3fdc9e&scoped=true&"
import script from "./TypeItem.vue?vue&type=script&lang=js&"
export * from "./TypeItem.vue?vue&type=script&lang=js&"
import style0 from "./TypeItem.vue?vue&type=style&index=0&id=5d3fdc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fdc9e",
  null
  
)

export default component.exports